import { hasLanguage } from 'ha/helpers/routes/hasLanguage';
import { LoadableNotFoundPage } from 'ha/pages/NotFound';

export const getIndexRouteLang =
  (getComponentsWithNotFound, pageName = 'Home') =>
  (location, cbLang) => {
    if (hasLanguage(location)) {
      return cbLang(null, {
        getComponents: getComponentsWithNotFound(pageName),
      });
    }

    return cbLang(null, {
      component: LoadableNotFoundPage,
    });
  };
